import { Vestiging } from "@/entities/vestiging";
import { LokaleVestigingenSection } from "./lokale-vestiging-section";
import { NsRetailVestigingenSection } from "./ns-retail-vestiging-section.tsx";

interface BehandeldeAanvragenKlantenserviceProps {
    vestigingen: Vestiging[];
}

export function BehandeldeAanvragenKlantenservice({ vestigingen }: Readonly<BehandeldeAanvragenKlantenserviceProps>) {
    const nsRetailVestigingen = vestigingen.filter((v) => v.beheerVestiging.isNsRetailVestiging);
    const lokaleVestigingen = vestigingen.filter((v) => !v.beheerVestiging.isNsRetailVestiging);

    const nsRetailVestigingenByStation = Vestiging.groupByStation(nsRetailVestigingen);
    const lokaleVestigingenByStation = Vestiging.groupByStation(lokaleVestigingen);

    return (
        <div className="space-y-6">
            {nsRetailVestigingen.length > 0 && <NsRetailVestigingenSection vestigingenByStation={nsRetailVestigingenByStation} />}
            {lokaleVestigingen.length > 0 && <LokaleVestigingenSection vestigingenByStation={lokaleVestigingenByStation} />}
        </div>
    );
}
